import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardBody, MDBIcon, MDBRow, MDBCol, MDBCardText, MDBCardImage, MDBCardTitle, MDBJumbotron, MDBContainer } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import MobiEnvironment from '../Utilities/MobiEnvironment'

class RecruitLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }

        this.mobiLocation = new MobiEnvironment();
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        console.log('TMAUser', this.TMAUser);
    }

    async componentDidMount() {
        //this.props.loaderOn();
        //var dl = new DataLayer();
        //let result = await dl.Get('/demonstrator/getnotifications', 200);
        //let coPaymentResult = await dl.Get('/copayment/GetCopayment', 200);
        ////console.log(coPaymentResult);
        //this.setState({
        //    hasNotifications: result.data.length > 0 ? true : false,
        //    mobiNotifications: result.data,
        //    copayments: coPaymentResult.data
        //});
        this.props.loaderOff();
    }

    

    render() {
        return (
            <div>
                <Header headerText='Self Register Link'
                    subHeaderText="(Copy and send the link below to all your social media handles.)"
                    hideSearch={true}
                />
                <br />
                <div style={{fontWeight:"bold"}}>
                    {this.mobiLocation.GetMobiUrl()}/register/{this.TMAUser.data.sfId}/{ this.TMAUser.data.unitId}
                </div>
            </div>

        )
    }
}

export default RecruitLink;